module.exports = __webpack_public_path__ + "static/media/update.233b2dd3.svg";